// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__9q251","text":"Divider_text__VMNL2","line":"Divider_line__WmHh8"};